'use strict';
const $ = jQuery.noConflict();
$(function() {

	const faqBlock = {

		init: function() {
			this.cacheDOM();
			if (!this.$block.length) return;

			this.bindAccordionEvents();
			this.bindNavEvents();
			this.initScrollSpy();
			this.initWaves();
		},

		cacheDOM: function() {
			this.$block = $('.faq');
			this.$lists = $('.js-faq-list');
			this.$navLinks = $('.js-faq-nav-link');
			this.$sections = $('.js-faq-section');
			this.$waves = $('.js-faq-waves');
			this.$wavePathBack = this.$waves.find('.faq__wave--back .faq__wave-svg path');
			this.$wavePathFront = this.$waves.find('.faq__wave--front .faq__wave-svg path');
		},

		// each category's question list closes its own items independently,
		// so opening a question in one section never collapses another section
		bindAccordionEvents: function() {
			this.$lists.each((index, list) => {
				const $items = $(list).find('.js-faq-item');

				$items.each((itemIndex, item) => {
					const $item = $(item);
					const $trigger = $item.find('.js-faq-trigger');
					$trigger.on('click', () => this.toggleItem($item, $items));
				});
			});
		},

		toggleItem: function($item, $items) {
			const isActive = $item.hasClass('is-active');
			this.closeItems($items);

			if (!isActive) {
				this.openItem($item);
			}
		},

		openItem: function($item) {
			const $trigger = $item.find('.js-faq-trigger');
			const $panel = $item.find('.js-faq-panel');

			$item.addClass('is-active');
			$trigger.attr('aria-expanded', 'true');
			$panel.css('max-height', $panel.prop('scrollHeight') + 'px');
		},

		closeItem: function($item) {
			const $trigger = $item.find('.js-faq-trigger');
			const $panel = $item.find('.js-faq-panel');

			$item.removeClass('is-active');
			$trigger.attr('aria-expanded', 'false');
			$panel.css('max-height', '');
		},

		closeItems: function($items) {
			$items.each((index, item) => this.closeItem($(item)));
		},

		bindNavEvents: function() {
			this.$navLinks.on('click', (e) => {
				const targetId = $(e.currentTarget).data('faqTarget');
				const target = targetId ? document.getElementById(targetId) : null;

				if (!target) return;

				e.preventDefault();
				target.scrollIntoView({behavior: this.prefersReducedMotion() ? 'auto' : 'smooth', block: 'start'});
			});
		},

		// highlights the nav link for whichever category section currently sits
		// in the middle band of the viewport as the visitor scrolls
		initScrollSpy: function() {
			if (!this.$sections.length || !this.$navLinks.length || !('IntersectionObserver' in window)) return;

			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return;
					this.setActiveNavLink(entry.target.id);
				});
			}, {rootMargin: '-10% 0px -60% 0px', threshold: 0});

			this.$sections.each((index, section) => observer.observe(section));
		},

		setActiveNavLink: function(sectionId) {
			this.$navLinks.removeClass('is-active');
			this.$navLinks.filter('[data-faq-target="' + sectionId + '"]').addClass('is-active');
		},

		// the wave layers each read one shared phase value at their own speed
		// and direction: the phase eases toward a target of scrollY * 0.004
		// every frame, so the waves keep rolling forward while the visitor
		// scrolls and settle to a stop within a few frames of them stopping.
		// Only runs while the section is on screen, and never at all when the
		// visitor prefers reduced motion (the original static artwork is left
		// untouched)
		initWaves: function() {
			if (!this.$waves.length || !this.$wavePathBack.length || !this.$wavePathFront.length) return;
			if (this.prefersReducedMotion()) return;

			this.isWavesInView = !('IntersectionObserver' in window);

			if ('IntersectionObserver' in window) {
				const observer = new IntersectionObserver((entries) => {
					entries.forEach((entry) => this.isWavesInView = entry.isIntersecting);
				}, {threshold: 0});

				observer.observe(this.$block.get(0));
			}

			this.wavePhase = 0;
			this.wavePhaseTarget = 0;
			this.waveRafId = null;
			this.waveLayers = [
				{$path: this.$wavePathBack, width: 1440, height: 267, y: 0.62, rise: 65, amp: 16, len: 1500, speed: 0.9, sign: 1},
				{$path: this.$wavePathFront, width: 1440, height: 258.864, y: 0.7, rise: 78, amp: 19, len: 1900, speed: 0.55, sign: -1},
			];

			this.renderWaves();

			$(window).on('scroll', () => this.handleWavesScroll());
		},

		handleWavesScroll: function() {
			if (!this.isWavesInView) return;

			this.wavePhaseTarget = window.scrollY * 0.004;

			if (!this.waveRafId) {
				this.waveRafId = requestAnimationFrame(() => this.tickWaves());
			}
		},

		// eases the shared phase toward its scroll-derived target each frame,
		// stopping the loop once they've converged so the waves sit still
		// until the next scroll event
		tickWaves: function() {
			const delta = this.wavePhaseTarget - this.wavePhase;

			if (Math.abs(delta) > 0.001) {
				this.wavePhase += delta * 0.07;
				this.renderWaves();
				this.waveRafId = requestAnimationFrame(() => this.tickWaves());
			} else {
				this.wavePhase = this.wavePhaseTarget;
				this.renderWaves();
				this.waveRafId = null;
			}
		},

		renderWaves: function() {
			this.waveLayers.forEach((layer) => {
				const phase = this.wavePhase * layer.speed * layer.sign;
				layer.$path.attr('d', this.buildWaveD(layer, phase));
			});
		},

		// traces a rolling swell across the viewBox width: a linear tilt from
		// left to right (rise) plus two sine harmonics (a big slow roll and a
		// smaller ripple riding on top of it), sampled at 29 points and closed
		// off at the bottom so it fills like the source art
		buildWaveD: function(layer, phase) {
			const {width, height, y, rise, amp, len} = layer;
			const steps = 28;
			const waveY = (progress, x) => y * height
				- progress * rise
				+ Math.sin((x / len) * Math.PI * 2 + phase) * amp
				+ Math.sin((x / (len * 0.47)) * Math.PI * 2 + phase * 1.6) * amp * 0.35;

			const points = [];
			for (let i = 0; i <= steps; i++) {
				const x = (i / steps) * width;
				points.push(x.toFixed(1) + ',' + waveY(i / steps, x).toFixed(1));
			}

			return 'M ' + points.join(' L ') + ' L ' + width + ',' + height + ' L 0,' + height + ' Z';
		},

		prefersReducedMotion: function() {
			return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		},

	};

	faqBlock.init();
});
